export default [
    {
        path: '/pages/group/productSeckillOrder',
        name: '/pages/group/productSeckillOrder',
        meta: { title: '秒杀订单' },
        component: () => import('@/views/group/productSeckillOrder.vue')
    },
    {
        path: '/pages/group/adminSeckillOrder',
        name: '/pages/group/adminSeckillOrder',
        meta: { title: '秒杀订单' },
        component: () => import('@/views/group/adminSeckillOrder.vue')
    },
    {
        path: '/pages/group/productGroupManage',
        name: '/pages/group/productGroupManage',
        meta: { title: '拼团商品' },
        component: () => import('@/views/group/productGroupManage.vue')
    },
    {
        path: '/pages/group/productGroupOrderManage',
        name: '/pages/group/productGroupOrderManage',
        meta: { title: '拼团订单' },
        component: () => import('@/views/group/productGroupOrderManage.vue')
    },
    {
        path: '/pages/group/productGroupOrderReturn',
        name: '/pages/group/productGroupOrderReturn',
        meta: { title: '拼团退单' },
        component: () => import('@/views/group/productGroupOrderReturn.vue')
    },
    {
        path: '/pages/group/productSeckillManage',
        name: '/pages/group/productSeckillManage',
        meta: { title: '秒杀商品' },
        component: () => import('@/views/group/productSeckillManage.vue')
    },
    {
        path: '/pages/group/adminGroup',
        name: '/pages/group/adminGroup',
        meta: { title: '店铺拼团' },
        component: () => import('@/views/group/adminGroup.vue')
    },
    {
        path: '/pages/group/adminGroupOrder',
        name: '/pages/group/adminGroupOrder',
        meta: { title: '拼团订单' },
        component: () => import('@/views/group/adminGroupOrder.vue')
    },
    {
        path: '/pages/group/adminRefundGroupOrder',
        name: '/pages/group/adminRefundGroupOrder',
        meta: { title: '拼团退单' },
        component: () => import('@/views/group/adminRefundGroupOrder.vue')
    },
    {
        path: '/pages/group/adminSeckill',
        name: '/pages/group/adminSeckill',
        meta: { title: '店铺秒杀' },
        component: () => import('@/views/group/adminSeckill.vue')
    }
] 